var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.mainTable.sarchCardShow
            ? _c(
                "Row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "24" } },
                    [
                      _c("search-card", {
                        attrs: {
                          form: _vm.mainTable.searchForm,
                          "table-load-event": _vm.getMainTableRecords,
                          "table-search": _vm.mainTable.tableSearch,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "Card",
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c("Col", { attrs: { span: "24" } }, [
                _c("div", { staticClass: "global-tool-bar" }, [
                  _c("div", { staticClass: "left-bar" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("产品审批记录"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "right-bar" },
                    [
                      _vm.$checkAccessArray(["B", "C"])
                        ? _c(
                            "Button",
                            {
                              staticClass: "btns",
                              attrs: {
                                size: "small",
                                shape: "circle",
                                type: "success",
                                icon: "ios-add-circle-outline",
                              },
                              on: { click: _vm.onCreate },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _c(
                        "Button",
                        {
                          staticClass: "btns",
                          attrs: {
                            type: "primary",
                            size: "small",
                            shape: "circle",
                            icon: "ios-search",
                          },
                          on: {
                            click: function ($event) {
                              _vm.mainTable.sarchCardShow =
                                !_vm.mainTable.sarchCardShow
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("stand-pagination-table", {
                    attrs: {
                      columns: _vm.mainTable.tableColumns,
                      data: _vm.mainTable.tableData,
                      loading: _vm.mainTable.tableLoading,
                      "table-search": _vm.mainTable.tableSearch,
                      "table-load-event": _vm.getMainTableRecords,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ProductApproveDetail", { ref: "productApproveDetailModal" }),
      _c("ProductApproveCreate", { ref: "productApproveCreateModal" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }